import moment from 'moment-timezone';

export const SANTIAGO_TZ = 'America/Santiago';

export type SchedulePeriodUnit = 'days' | 'weeks' | 'months' | 'years';

/** Keep in sync with stem-web-backend/src/database/utils/santiagoSchedule.ts */

export function toSantiagoCivilDate(value: unknown): string | null {
  if (value == null || value === '') return null;
  const ymd = moment(value).tz(SANTIAGO_TZ).format('YYYY-MM-DD');
  return ymd === 'Invalid date' ? null : ymd;
}

export function addCivilDate(ymd: string, amount: number, unit: SchedulePeriodUnit): string {
  return moment.utc(ymd, 'YYYY-MM-DD', true).add(amount, unit).format('YYYY-MM-DD');
}

export function santiagoInstantFromCivilDate(ymd: string) {
  return moment.tz(ymd, 'YYYY-MM-DD', SANTIAGO_TZ);
}

export function listScheduleCivilDates(opts: {
  inicio: unknown;
  fin: unknown;
  periodicidad: unknown;
  tipoPeriodicidad?: string | null;
  daysOfWeek?: Array<number | string> | null;
}): string[] {
  const startYmd = toSantiagoCivilDate(opts.inicio);
  const endYmd = toSantiagoCivilDate(opts.fin);
  if (!startYmd || !endYmd || startYmd > endYmd) return [];

  const step = Math.max(1, parseInt(String(opts.periodicidad), 10) || 1);
  const unit = (opts.tipoPeriodicidad || 'days') as SchedulePeriodUnit;
  const dates: string[] = [];

  if (unit === 'weeks') {
    const daysOfWeek = (opts.daysOfWeek || []).map((d) => Number(d)).filter((d) => d >= 1 && d <= 7);
    if (!daysOfWeek.length) return [];

    let weekStart = moment.utc(startYmd, 'YYYY-MM-DD', true).startOf('isoWeek').format('YYYY-MM-DD');

    while (weekStart <= endYmd) {
      for (const dayOfWeek of daysOfWeek) {
        const ymd = addCivilDate(weekStart, dayOfWeek - 1, 'days');
        if (ymd >= startYmd && ymd <= endYmd) dates.push(ymd);
      }
      const next = addCivilDate(weekStart, step, 'weeks');
      if (next <= weekStart) break;
      weekStart = next;
    }
    return dates;
  }

  if (!['days', 'months', 'years'].includes(unit)) {
    return listScheduleCivilDates({...opts, tipoPeriodicidad: 'days'});
  }

  let cursor = startYmd;
  while (cursor <= endYmd) {
    dates.push(cursor);
    const next = addCivilDate(cursor, step, unit);
    if (next <= cursor) break;
    cursor = next;
  }
  return dates;
}
